const ExcelJS = require("exceljs");
const downloadFile = require("./utils/downloadFile");
const periodsTable = require("./modules/entries/periodsTable");
const header = require("./modules/header");
const formatName = require("./utils/formatName");
const { VUE_APP_PLATFORM_NAME } = process.env;
const moment = require("moment");

module.exports = async ({ organization, members }) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = VUE_APP_PLATFORM_NAME;
  workbook.lastModifiedBy = VUE_APP_PLATFORM_NAME;

  workbook.title = `Filiações - ${organization.name}`;
  workbook.created = new Date();

  const sheetResume = workbook.addWorksheet("Filiados", {
    properties: { tabColor: { argb: "242939" } },
  });
  const columns = [
    { header: "Nome", key: "name", width: 30 },
    { header: "WhatsApp", key: "phone", width: 20 },
    { header: "Documento", key: "document", width: 20 },
    { header: "Plano", key: "membership", width: 20 },
    // { header: "Status", key: "status", width: 20 },
    { header: "Validade", key: "validUntil", width: 20},
    { header: "Data de criação", key: "createdAt", width: 20 },
  ];
  sheetResume.columns = columns.flat();
  var headerRow = sheetResume.getRow(1);
  headerRow.eachCell({ includeEmpty: true }, function (cell) {
    cell.font = { bold: true };
  });

  await header(workbook, sheetResume, { title: "Filiações", organization });

  const lastColumn = String.fromCharCode(65 + columns.length - 1);

  members.forEach(member => {
    sheetResume.addRow({
      name: member.name,
      phone: member.phone,
      document: member.document,
      membership: member.membership.name,
      filiation: member.filiation.name,
      // status: member.filiationStatus,
      validUntil: moment(member.lastPurchase.validUntil).format("DD/MM/YYYY"),
      createdAt: moment(member.lastPurchase.createdAt).format("DD/MM/YYYY"),
    });
  });

  // format the validUntil column to be a date
  sheetResume.getColumn("E").numFmt = "DD/MM/YYYY";

  // Use conditional formatting to color the validUntil column is the date is expired
  sheetResume.addConditionalFormatting({
    ref: `E4:E${members.length + 3}`,
    rules: [
      {
        type: "expression",
        formulae: ["F4 < TODAY()"],
        style: { font: { color: { argb: "FFB23939" }, bold: true } },
      },
      {
        type: "expression",
        formulae: ["F4 >= TODAY()"],
        style: { font: { color: { argb: "FF408243" }, bold: true } },
      },
    ],
  });


  downloadFile(workbook, `Filiações - ${organization.name}`);

  return true;
};
